import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFeed, createPost, likePost, commentPost } from '../redux/postSlice';
import PostForm from '../components/PostForm';
import PostCard from '../components/PostCard';
import TopUsersBox from '../components/TopUsersBox';
import StoriesBox from '../components/StoriesBox';
import MusicPlayer from '../components/MusicPlayer';
import UpdatesBox from '../components/UpdatesBox';
import '../styles/Home.css';

const Home = () => {
  const dispatch = useDispatch();
  const { posts, loading } = useSelector(state => state.posts);

  useEffect(() => {
    dispatch(fetchFeed());
  }, [dispatch]);

  const handlePostCreate = (data) => {
    dispatch(createPost(data));
  };

  const handleLike = (postId) => {
    dispatch(likePost(postId));
  };

  const handleComment = (postId, text) => {
    dispatch(commentPost({ postId, text }));
  };

  return (
    <div className="home-container">
      <div className="home-layout">
        <div className="feed-section">
          <StoriesBox />
          <PostForm onSubmit={handlePostCreate} />
          
          {loading && <div className="loading">Loading posts...</div>}
          
          <div className="posts-list">
            {posts.map(post => (
              <PostCard
                key={post._id}
                post={post}
                onLike={handleLike}
                onComment={handleComment}
              />
            ))}
          </div>
        </div>

        <div className="sidebar-section">
          <UpdatesBox />

          <TopUsersBox />
          
          <MusicPlayer />
        </div>
      </div>
    </div>
  );
};

export default Home;
